import type { FC } from 'react';
import { TextShimmer } from '~/components/ui/TextShimmer';
import { classNames } from '~/utils/classNames';

export interface AssistantThinkingProps {
  className?: string;
  includeIcon?: boolean;
}

export const AssistantThinking: FC<AssistantThinkingProps> = ({ className, includeIcon }) => {
  return (
    <div className={classNames('flex h-6 items-center', className)}>
      {includeIcon && (
        <div className="h-6 flex items-center">
          <i className="i-mdi:brain size-4.5 shrink-0 mr-1 text-bolt-elements-icon opacity-60 transition-theme" />
        </div>
      )}
      <TextShimmer className="[--base-color:var(--bolt-elements-textTertiary)] dark:[--base-color:var(--bolt-elements-textSecondary)] [--base-gradient-color:var(--bolt-elements-textPrimary)]">
        Thinking...
      </TextShimmer>
    </div>
  );
};
